import { AdyenCheckout, Dropin } from "@adyen/adyen-web";
import "@adyen/adyen-web/styles/adyen.css";
import Loader from "components/molecules/loader";
import { environment } from "config/envConfig";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const AdyenDropIn = (props) => {
  const dropInRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initiateDropIn();
  }, []);

  const initiateDropIn = async () => {
    let paymentConfig = {
      session: {
        id: props?.paymentSession?.id, // Unique identifier for the payment session.
        sessionData: props?.paymentSession?.sessionData, // The payment session data.
      },
      environment: environment.includes("dev") ? "test" : "live", // Change to 'live' for the live environment.
      amount: {
        value: props?.paymentSession?.amount?.value,
        currency: props?.paymentSession?.amount?.currency,
      },
      locale: props?.paymentSession?.shopperLocale,
      countryCode: props?.paymentSession?.countryCode,
      clientKey: props?.clientSecret, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
      onPaymentCompleted: (result, component) => {
        console.log("onPaymentCompleted", result, component);
        props?.handlePaymentCompleted(result);
      },
      onPaymentFailed: (result, component) => {
        console.log("onPaymentFailed", result, component);
        props?.handlePaymentFailed(result);
      },
      onError: (error, component) => {
        console.log(
          "onError",
          error.name,
          error.message,
          error.stack,
          component
        );
        props?.handlePaymentError(error);
      },
    };
    const checkout = await AdyenCheckout(paymentConfig);
    const dropinConfiguration = {
      paymentMethodComponents: [],
      paymentMethodsConfiguration: {
        // card: {
        //   // Optional configuration.
        //   hasHolderName: true, // Show the cardholder name field.
        //   holderNameRequired: true, // Mark the cardholder name field as required.
        // },
      },
      onReady: () => {},
    };
    const dropin = new Dropin(checkout, dropinConfiguration).mount(
      dropInRef?.current
    );
  };

  if (isLoading) {
    return <Loader />;
  } else {
    return (
      <Wrapper>
        <DropInWrapper
          disabled={props?.disabled}
          ref={dropInRef}
        ></DropInWrapper>
      </Wrapper>
    );
  }
};

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;
const DropInWrapper = styled.div`
  width: 100%;
  position: relative;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
`;

export default AdyenDropIn;
